import moment from "moment";

export const formatDate = (
  date?: Date,
  from = "YYYY-MM-DD",
  to = "DD/MM/YYYY"
) => {
  return date ? moment(date, from).format(to) : "";
};

export const isValidDate = (value: string, strict: boolean = false) => {
  return moment(value, "YYYY-MM-DD", strict).isValid();
};

export const reverseDate = (datestr = "", splitWith = "/", joinWith = "/") => {
  return datestr?.split(splitWith).reverse().join(joinWith);
};

export const compareDates = (date1?: Date, date2?: Date) => {
  if (!date1 || !date2 || isNaN(date1?.getTime()) || isNaN(date2?.getTime())) {
    return -2;
  }
  if (
    moment(date1).format("DD/MM/YYYY") === moment(date2).format("DD/MM/YYYY")
  ) {
    return 0;
  }
  return date1 < date2 ? -1 : 1;
};

export const compareFullDates = (date1?: Date, date2?: Date) => {
  if (!date1 || !date2 || isNaN(date1?.getTime()) || isNaN(date2?.getTime())) {
    return -2;
  }
  if (
    moment(date1).format("DD/MM/YYYYTHH:mm") ===
    moment(date2).format("DD/MM/YYYYTHH:mm")
  ) {
    return 0;
  }
  return date1 < date2 ? -1 : 1;
};

const toUTCDate = (s: string) => {
  const [d, m, y] = s.split("/").map(Number);
  return Date.UTC(y, m - 1, d);
};

export const getDifferenceInDays = (d1?: string, d2?: string) => {
  if (!d1 || !d2) return -1;
  const t1 = toUTCDate(d1);
  const t2 = toUTCDate(d2);
  return Math.abs((t2 - t1) / 86400000);
};

export const addDays = (days: number) => {
  const date = new Date();
  date.setDate(date.getDate() + days);
  return date;
};

export const addStartDays = (start_date: string, days: number) => {
  const date = new Date(start_date);
  date.setDate(date.getDate() + days);
  return date;
};

export const extactTimeFromDateString = (date: string | undefined) => {
  if (!date) return "";

  return date?.split("T")[1]?.slice(0, 5) || "";
};

export const extractDateFromDateString = (date: string | undefined) => {
  if (!date) return "";

  return date?.split("T")[0]?.split("-")?.reverse()?.join("/") || "";
};

export const getCurrentDate = () => {
  return moment().format("DD/MM/YYYY");
};

export const getCurrentDateHour = () => {
  return moment().hour();
};

export const getCurrentMinute = () => {
  return moment().minute();
};
